import { GoDotFill } from "react-icons/go";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@/components/Global/Tooltip";
import { quickBooksStatusValue } from "@/utils/constants";

const QuickbooksStatusChip = ({ status, title }) => {
  return status == quickBooksStatusValue.COMPLETED ? (
    <p className="bg-customGreen-light text-sm font-medium py-0.5 px-2.5 rounded-full text-customGreen-text flex gap-2 items-center">
      <GoDotFill className="text-customGreen-lightLabel" />{" "}
      {quickBooksStatusValue.COMPLETED}
    </p>
  ) : status == quickBooksStatusValue.NOT_SYNC ? (
    <p className="bg-customGrey-light text-sm font-medium py-0.5 px-2.5 rounded-full text-customGrey-dark flex gap-2 items-center">
      <TbRefresh className="text-customGrey-dark" />{" "}
      {quickBooksStatusValue.NOT_SYNC}
    </p>
  ) : (
    <Tooltip
      text={`Enter all the necessary information and click save to sync the ${title}`}
    >
      <p className="bg-customGrey-light text-sm font-medium py-0.5 px-2.5 rounded-full text-customGrey-dark flex gap-2 items-center">
        <TbRefresh className="text-customGrey-dark" />{" "}
        {quickBooksStatusValue.NOT_READY}
      </p>
    </Tooltip>
  );
};

export default QuickbooksStatusChip;
